import { Form, Stack } from '@servicetitan/design-system';

type FormFooterButtonsProps = {
  loading: boolean;
  saveDisabled?: boolean;
  primaryText: string;
  primaryLocator?: string;
  secondaryLocator?: string;
  secondaryText: string;
  onSecondaryClick: () => void;
  onPrimaryClick: () => void;
};

const FormFooterButtons = ({
  loading,
  saveDisabled,
  primaryText,
  primaryLocator,
  secondaryLocator,
  secondaryText,
  onSecondaryClick,
  onPrimaryClick,
}: FormFooterButtonsProps) => {
  return (
    <Stack spacing={2}>
      <Form.Button
        disabled={loading}
        className='m-b-0'
        id={secondaryLocator}
        onClick={onSecondaryClick}
      >
        {secondaryText}
      </Form.Button>
      <Form.Button
        id={primaryLocator}
        loading={loading}
        className='m-b-0'
        primary
        disabled={saveDisabled || loading}
        onClick={onPrimaryClick}
      >
        {primaryText}
      </Form.Button>
    </Stack>
  );
};

export default FormFooterButtons;
